import Vue from "vue"
import Vuex from "vuex"
import axios from "axios"
import ViewUI from "view-design"
import "view-design/dist/styles/iview.css"

import App from "@/App"
import store from "@/store"
import router from "@/router"
import "@/assets/style.css"

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL,
})

axiosInstance.interceptors.request.use(
  config => {
    store.commit("SET_LOADING", true)
    return config
  },
  error => {
    store.commit("SET_LOADING", false)
    return Promise.reject(error)
  }
)
axiosInstance.interceptors.response.use(
  response => {
    store.commit("SET_LOADING", false)
    return response
  },
  error => {
    store.commit("SET_LOADING", false)
    return Promise.reject(error)
  }
)

Vue.prototype.$http = axiosInstance
Vuex.Store.prototype.$http = axiosInstance
Vue.config.productionTip = false

Vue.use(ViewUI)

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount("#app")
